import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate, {
  delay: 400,
  fieldsBagName: "formFields",
  classes: true,
  classNames: {
    invalid: "is-invalid"
  },
  events: "change"
});
